import { Component } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'itl-pdf-box',
  templateUrl: './pdf-box.component.html',
  styleUrls: ['./pdf-box.component.scss'],
})
export class PdfBoxComponent {
  public fileName: string;
  public src: ArrayBuffer;
  public currentPage = 1;
  public zoom = 1;

  private readonly MIN_ZOOM = 0.5;
  private readonly MAX_ZOOM = 5;
  private readonly ZOOM_STEP = 0.25;

  public get isIos() {
    return this._platform.is('ios');
  }

  constructor(public _modalCtrl: ModalController, private _platform: Platform) {}

  public zoomIn(): void {
    this.zoom = Math.min(this.zoom + this.ZOOM_STEP, this.MAX_ZOOM);
  }

  public zoomOut(): void {
    this.zoom = Math.max(this.zoom - this.ZOOM_STEP, this.MIN_ZOOM);
  }

  public resetZoom(): void {
    this.zoom = 1;
  }
}
